import React, { useState } from "react"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem
} from "reactstrap"

import logo from "../images/logo.svg"
import { PHONE, EMAIL } from "../utils/constants"

const menu = [
  {
    anchor: "/#lead",
    title: "Главное"
  },
  {
    anchor: "/#cases",
    title: "Наши кейсы"
  },
  {
    anchor: "/#ratings",
    title: "Мы в рейтингах"
  },
  // {
  //   anchor: "/#partners",
  //   title: "О нас пишут"
  // },
  {
    anchor: "/#team",
    title: "Команда"
  },
  {
    anchor: "/#contacts",
    title: "Контакты"
  }
]

const Header = props => {
  const { siteTitle } = props
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
    document.body.classList.toggle("menu-opened")
  }
  return (
    <header className={isOpen ? "header open" : "header"}>
      <Navbar expand="md">
        <Container>
          <div className="header_logo">
            <Link to="/">
              <img src={logo} alt={siteTitle} width="200px" />
            </Link>
            <div className="header_logo__text">
              сервис создан при поддержке Аронов&nbsp;и&nbsp;Партнеры
            </div>
          </div>
          <NavbarToggler onClick={toggle} className={isOpen ? "active" : ""} />
          <Collapse isOpen={isOpen} navbar>
            <div className="navbar-collapse__inner">
              <div className="header_info">
                <div className="header_info__item">
                  <h5 className="header_info__title">Телефон</h5>
                  <div className="header_info__value">
                    <a href={`tel:${PHONE}`}>{PHONE}</a>
                  </div>
                </div>
                <div className="header_info__item">
                  <h5 className="header_info__title">Email</h5>
                  <div className="header_info__value">
                    <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                  </div>
                </div>
              </div>
              <Nav className="d-md-none" navbar>
                {menu.map((item, i) => (
                  <NavItem key={i} onClick={() => setTimeout(toggle, 600)}>
                    <AnchorLink
                      className="nav-link"
                      to={item.anchor}
                      title={item.title}
                      activeClassName="active"
                    />
                  </NavItem>
                ))}
              </Nav>
            </div>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default Header
